/**
 * Function to control the modal
 * 
 * @param {HTMLElement} accountModal target id tag of the modal
 * @param {string} modalHeaderMSG header message
 * 
 * @returns void
 */
export const modalControl = (accountModal: HTMLElement, modalHeaderMSG?: string, formTag?: string) => {
  const accountModalclose = document.querySelector('.modal-close') as HTMLElement;
  const modalHeader = document.querySelector('.modal-title') as HTMLElement;

  accountModal.style.display = 'block';

  if ( modalHeaderMSG !== '' ) {
    modalHeader.innerText = modalHeaderMSG!;
  }

  let selector = formTag ? formTag : '#aafp_add-new-tax';
  let form = document.querySelector(selector) as HTMLFormElement;
  
  accountModalclose.onclick = function() {
    accountModal.style.display = 'none';
    modalHeader.innerText = '';
    form.reset();
    let drops = document.querySelectorAll<HTMLElement>('.aafp_dropdown-button');
    drops.forEach(e =>  {
      e.removeAttribute('data-value');
      e.innerText = 'Please Select';
    });
  }
}